"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mock = void 0;
var mock = exports.mock = {
  layout: {
    title: 'Цена на туры в Грецию снизилась!'
  },
  webmail: {
    link: null
  },
  header: {
    image: 'https://s3.yc.level.travel/seo_images/RU/x1600x500_Russia-tiny.jpg'
  },
  partner: {
    link: 'https://level.travel?utm_source=price-watch'
  },
  offer: {
    start_date: '2020-10-01',
    nights_count: 2,
    tourists_count: 3,
    destination_name: 'на Мальдивы',
    departure_city: 'Нижнего Новгорода',
    type: 'min_price',
    subtype: 'price_fell',
    flex_dates: true,
    flex_nights: true,
    price: 77350,
    surcharge: 10000,
    price_diff: {
      direction: 'down',
      old_price: 91630,
      diff_price: 14280,
      diff_percentage: 15
    },
    offer_link: 'https://level.travel/packages/98889195/?utm_source=price-watch'
  },
  organization: {
    name: 'Левел Путешествия',
    inn: '9701074247',
    ogrn: '1117746723808'
  },
  unsubscribe: {
    link: 'https://level.travel/unsubscribe/?utm_source=price-watch'
  },
  subscription_token: '123213',
  graph: {
    link: 'https://level.travel/price_history/random.png',
    surcharge: 'present'
  },
  price_matrix: {
    surcharges: 'fully_known',
    matrix: {
      '2020-09-27': {
        2: {
          full_price: 0,
          surcharge: 0,
          price_per_night: 0,
          price_coefficient: 100,
          link: 'https://level.travel/?utm_source=price-watch'
        },
        3: {
          full_price: 112307,
          surcharge: 1000,
          price_per_night: 18717,
          price_coefficient: 55,
          link: 'https://level.travel/?utm_source=price-watch'
        },
        4: {
          full_price: 114423,
          surcharge: 1000,
          price_per_night: 16346,
          price_coefficient: 36,
          link: 'https://level.travel/?utm_source=price-watch'
        },
        5: {
          full_price: 116354,
          surcharge: null,
          price_per_night: 14544,
          price_coefficient: 21,
          link: 'https://level.travel/?utm_source=price-watch'
        },
        6: {
          full_price: 118194,
          surcharge: 1000,
          price_per_night: 13132,
          price_coefficient: 9,
          link: 'https://level.travel/?utm_source=price-watch'
        }
      },
      '2020-09-28': {
        2: {
          full_price: 0,
          surcharge: 0,
          price_per_night: 0,
          price_coefficient: 100,
          link: 'https://level.travel/?utm_source=price-watch'
        },
        3: {
          full_price: 108904,
          surcharge: 0,
          price_per_night: 18150,
          price_coefficient: 50,
          link: 'https://level.travel/?utm_source=price-watch'
        },
        4: {
          full_price: 112767,
          surcharge: 3443,
          price_per_night: 16109,
          price_coefficient: 34,
          link: 'https://level.travel/?utm_source=price-watch'
        },
        5: {
          full_price: 108676,
          surcharge: null,
          price_per_night: 13584,
          price_coefficient: 13,
          link: 'https://level.travel/?utm_source=price-watch'
        },
        6: {
          full_price: 112547,
          surcharge: 0,
          price_per_night: 12505,
          price_coefficient: 4,
          link: 'https://level.travel/?utm_source=price-watch'
        }
      },
      '2020-09-29': {
        2: {
          full_price: 212381,
          surcharge: 4985,
          price_per_night: 30340,
          price_coefficient: 50,
          link: 'https://level.travel/?utm_source=price-watch'
        },
        3: {
          full_price: 0,
          surcharge: 0,
          price_per_night: 0,
          price_coefficient: 100,
          link: 'https://level.travel/?utm_source=price-watch'
        },
        4: {
          full_price: 212381,
          surcharge: 1000,
          price_per_night: 30340,
          price_coefficient: 151,
          link: 'https://level.travel/?utm_source=price-watch'
        },
        5: {
          full_price: 207927,
          surcharge: 1000,
          price_per_night: 25990,
          price_coefficient: 115,
          link: 'https://level.travel/?utm_source=price-watch'
        },
        6: {
          full_price: 112608,
          surcharge: 1000,
          price_per_night: 12512,
          price_coefficient: 4,
          link: 'https://level.travel/?utm_source=price-watch'
        }
      },
      '2020-09-30': {
        2: {
          full_price: 0,
          surcharge: 0,
          price_per_night: 0,
          price_coefficient: 100,
          link: 'https://level.travel/?utm_source=price-watch'
        },
        3: {
          full_price: 0,
          surcharge: 0,
          price_per_night: 0,
          price_coefficient: 100,
          link: 'https://level.travel/?utm_source=price-watch'
        },
        4: {
          full_price: 0,
          surcharge: 0,
          price_per_night: 0,
          price_coefficient: 100,
          link: 'https://level.travel/?utm_source=price-watch'
        },
        5: {
          full_price: 207927,
          surcharge: 0,
          price_per_night: 25990,
          price_coefficient: 115,
          link: 'https://level.travel/?utm_source=price-watch'
        },
        6: {
          full_price: 108904,
          surcharge: 0,
          price_per_night: 12100,
          price_coefficient: 0,
          link: 'https://level.travel/?utm_source=price-watch',
          best_offer: true
        }
      },
      '2020-10-01': {
        2: {
          full_price: 0,
          surcharge: 0,
          price_per_night: 0,
          price_coefficient: 100,
          link: 'https://level.travel/?utm_source=price-watch'
        },
        3: {
          full_price: 0,
          surcharge: 0,
          price_per_night: 0,
          price_coefficient: 100,
          link: 'https://level.travel/?utm_source=price-watch'
        },
        4: {
          full_price: 107548,
          surcharge: 0,
          price_per_night: 15364,
          price_coefficient: 27,
          link: 'https://level.travel/?utm_source=price-watch'
        },
        5: {
          full_price: 114475,
          surcharge: 0,
          price_per_night: 14309,
          price_coefficient: 19,
          link: 'https://level.travel/?utm_source=price-watch'
        },
        6: {
          full_price: 120586,
          surcharge: 0,
          price_per_night: 13398,
          price_coefficient: 11,
          link: 'https://level.travel/?utm_source=price-watch'
        }
      }
    }
  }
};